
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import xml from "csi/xml";
import Controller from "csi/action/Controller";
import { Context } from "csi/def/Context";
import { routerStore } from "csi/state/rootStore";

const RecipePrintLabelController = declare(Controller, {

	/**
	 * @override
	 * Pass the currently selected SKU to the label action
	 */
	toWriterRequest(ctx: Context): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		call.removeParameter("URL");
		call.addParameter("URL", xml.ATTR_REF, routerStore.locationRevisionUrl);
		return call;
	},


});

export = RecipePrintLabelController;
